import React, {useEffect, useState} from 'react';
import {Zone} from "types/Zone";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useOperator} from "context/OperatorContext";

type Props = {
    zone: Zone | null
    show: boolean
    onDelete?: (zone: Zone) => any
    onDeleteFail?: (zone: Zone, error: unknown) => any
    onCancel?: () => any
}

function DeleteZone(props: Props) {
    const {termFor} = useOperator()
    const {zone, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(zone?.name || `this ${termFor('zone')}`);
    const {mutateAsync: deleteZone} = useMutation(ngage.zones.destroy)

    useEffect(() => {
        if(zone) setName(zone.name)
    }, [zone]);

    async function handleDeleteZone() {
        if (zone) {
            try {
                await deleteZone(zone.id)
                await invalidate('zones.all')

                if (onDelete) onDelete(zone)
            } catch (error) {
                if (onDeleteFail) onDeleteFail(zone, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title={`Delete ${termFor('Zone')}`}
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteZone}
            onCancel={handleCancel}
        />
    );
}

export default DeleteZone;